import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#E0E0E0",
    "col1n": "#FFFFFF",
    "col2d": "#252525",
    "col2n": "#000000"
}
function AccMor104({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M20.65 9.45q.85-1.35 1.6-2.65.55-.95 1.05-1.85.1-.25.2-.45.45-.9.5-1.95.05-.95-.2-2.05-.05-.25-.15-.5l-4.7.3q-3.2.1-6.35.1Q9.45.4 6.4.3 3.9.2 1.5 0q-.1.25-.15.5-.3 1.1-.25 2.05 0 1.05.45 1.95.1.2.25.45.45.9 1 1.85.75 1.3 1.65 2.65.5.8 1.05 1.6 0 .05.05.1l.2.3q.05.1.1.15.25.35.45.6.25.3.35.35L0 45.8 12.6 63l.25-.5L25.1 45.8l-6.65-33.25q.1-.05.35-.35.15-.25.4-.6.05-.05.1-.15l.2-.3.1-.1q.5-.8 1.05-1.6z"
                    id="AccMor104__Symbol_229_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M12.55 2l-.45-2q-1.3.35-2.6.5h-.05Q7.85.75 6.3.75h-.7Q4.45.75 3.35.6H3.3Q1.8.4.35 0L0 2.05q1.55.45 3.15.65 1.55.2 3.15.2 1.7 0 3.35-.25h.05q1.4-.2 2.85-.65z"
                    id="AccMor104__Symbol_228_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M12.15 63v-3.75H9.4L12.15 63m6.1-12.3l.25 3.5 2.55-3.5h-2.8m-6.1 4.3v-4.3H6l-.3 3.5.6.8h5.85m0 0v4.25h2.65L17.95 55h-5.8m4.8-21.4l.3 4.25h5.8l-.85-4.25h-5.25m-4.8 4.25V33.6h-4.7l-.35 4.25h5.05m5.45 4.3l.3 4.25h6.3l.45-.6-.7-3.65H17.6m.3 4.25h-5.75v4.3h6.1l-.35-4.3m-.65-8.55h-5.1v4.3h5.45l-.35-4.3M6.7 42.15l-.35 4.25h5.8v-4.25H6.7m-.35 4.25H0l3.15 4.3H6l.35-4.3m.35-4.25l.4-4.3H1.15l-.85 4.3h6.4m.75-8.55l.35-4.3H2.85L2 33.6h5.45M16.3 25l.3 4.3h4.75L20.5 25h-4.2m-4.15 4.3V25h-4l-.35 4.3h4.35m0 4.3h4.8l-.35-4.3h-4.45v4.3m3.8-12.85h-3.8V25h4.15l-.35-4.25m-.3-4.3l-.1-1.25h-.05q-1.75-2.1-3.35.25v1h3.5m3.15 0h-3.15l.3 4.3h3.7l-.85-4.3m-10.3 4.3H4.55L3.7 25h4.45l.35-4.25m.4-4.3l-.4 4.3h3.65v-4.3H8.9m.1-1.2q-1.15-2.35-3.15-.65l-.4 1.85H8.9l.1-1.2m-.55-4.2q.2.55.45 1.15.15.45.35.95 1.1.15 2.2.15h.7v-2.25h-3.7M4 9.45q.5.8 1.05 1.6h3.4q-.35-.8-.6-1.6-.45-1.35-.8-2.65h-4.7Q3.1 8.1 4 9.45m2.15-6.9Q6 1.5 5.95.5V.3Q3.45.2 1.05 0 .95.25.9.5.6 1.6.65 2.55h5.5m6 4.25V2.55h-6q.15 1.15.4 2.4.2.9.5 1.85h5.1m7 4.25h-3.1q-.25.55-.45 1.15-.2.45-.35.85-.2 0-.3.05l.35-.05h.05q1.3-.15 2.6-.5l.05.15v-.15q.1-.05.35-.35.15-.25.4-.6.05-.05.1-.15l.2-.3.1-.1m-7-4.25v4.25h3.9q.3-.8.55-1.6.45-1.35.85-2.65h-5.3m6.15-4.25q.15-1.05.2-2.05V.3q-3.2.1-6.35.1v2.15h6.15m3.5 4.25q.55-.95 1.05-1.85.1-.25.2-.45.45-.9.5-1.95H18.3q-.15 1.15-.4 2.4-.2.9-.45 1.85h4.35z"
                    id="AccMor104__Symbol_226_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M.35 0L0 2.05q1.55.45 3.15.65l.2-2.1H3.3Q1.8.4.35 0m9.3 2.65L9.45.5H9.4Q7.85.75 6.3.75V2.9q1.7 0 3.35-.25z"
                    id="AccMor104__Symbol_227_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#AccMor104__Symbol_229_0_Layer0_0_FILL"
                transform="translate(179.95 248.95)"
                id="AccMor104__col1n"
            />
            <use
                xlinkHref="#AccMor104__Symbol_228_0_Layer0_0_FILL"
                transform="translate(186.25 261.5)"
                id="AccMor104__col1d"
            />
            <use
                xlinkHref="#AccMor104__Symbol_226_0_Layer0_0_FILL"
                transform="translate(180.4 248.95)"
                id="AccMor104__col2n"
            />
            <use
                xlinkHref="#AccMor104__Symbol_227_0_Layer0_0_FILL"
                transform="translate(186.25 261.5)"
                id="AccMor104__col2d"
            />
        </g></g>
    )
}
export default AccMor104
